import * as React from "react";
const SvgGlobeSlated02 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.5 9.5a5 5 0 1 0-10 0 5 5 0 0 0 10 0m2 0a7 7 0 0 1-11.192 5.606l-1.069 1.068A8.5 8.5 0 0 0 17.511 3.49a1 1 0 1 1 1.414-1.415c4.1 4.101 4.1 10.75 0 14.85A10.45 10.45 0 0 1 13 19.892V21h4a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2h4v-1.012a10.46 10.46 0 0 1-6.184-2.391l-1.448 1.45a1 1 0 0 1-1.414-1.415l2.112-2.113.01-.009.01-.01 1.808-1.808A7 7 0 1 1 18.5 9.5"
}));
export default SvgGlobeSlated02;
//# sourceMappingURL=GlobeSlated02.js.map